/* global React, Icon, PlummeI18n, t */

const LOGIN_LANGUAGE_FLAGS = {
  no: '🇳🇴',
  en: '🇬🇧',
  sv: '🇸🇪',
  da: '🇩🇰',
  de: '🇩🇪',
  fr: '🇫🇷',
  es: '🇪🇸',
  pl: '🇵🇱',
};

function LoginLanguageSwitch() {
  const [open, setOpen] = React.useState(false);
  const rootRef = React.useRef(null);
  const toggleRef = React.useRef(null);
  const options = PlummeI18n.options();
  const locale = PlummeI18n.getLocale();
  const current = options.find((option) => option.value === locale) || options[0];

  React.useEffect(() => {
    if (!open) return undefined;

    const closeOnPointerDown = (event) => {
      if (!rootRef.current?.contains(event.target)) setOpen(false);
    };
    const closeOnEscape = (event) => {
      if (event.key !== 'Escape') return;
      setOpen(false);
      toggleRef.current?.focus();
    };

    document.addEventListener('pointerdown', closeOnPointerDown);
    document.addEventListener('keydown', closeOnEscape);
    return () => {
      document.removeEventListener('pointerdown', closeOnPointerDown);
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [open]);

  if (!current) return null;

  return (
    <div className="login-lang" ref={rootRef}>
      <button
        ref={toggleRef}
        type="button"
        className="login-lang-toggle"
        aria-label={`${t('auth.language')}: ${current.label}`}
        aria-expanded={open}
        aria-controls="login-language-menu"
        onClick={() => setOpen((value) => !value)}
      >
        <span aria-hidden="true">{LOGIN_LANGUAGE_FLAGS[current.value] || '🌐'}</span>
        <span>{current.label}</span>
        <span aria-hidden="true"><Icon name={open ? 'chevUp' : 'chevDown'} size={14} /></span>
      </button>

      {open ? (
        <div id="login-language-menu" className="login-lang-menu">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              className={`login-lang-option${option.value === locale ? ' active' : ''}`}
              aria-pressed={option.value === locale}
              onClick={() => {
                PlummeI18n.setLocale(option.value);
                setOpen(false);
              }}
            >
              <span aria-hidden="true">{LOGIN_LANGUAGE_FLAGS[option.value] || '🌐'}</span>
              <span>{option.label}</span>
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

window.LoginLanguageSwitch = LoginLanguageSwitch;
